import React, { FC } from 'react'

import { focusIds, orientation } from '@/constants/focus'
import { useCustomFocus } from '@/hooks/useCustomFocus'

import {
  SuggestionsItem,
  SuggestionsWrapper,
  SuggestionsItemWrapper,
  SuggestionsChip,
} from './styles'
import { SuggestionsProps } from './types'

export const Suggestions: FC<SuggestionsProps> = ({
  items,
  onSelect,
  focusIdPrefix,
}) => {
  const focusId = `${focusIdPrefix}${focusIds.SEARCH}${focusIds.SUGGESTIONS}`
  const { defaultFocusChild, onMove } = useCustomFocus({ focusId })
  const hasSuggestions = !!items.length

  return (
    <SuggestionsWrapper
      focusId={focusId}
      orientation={orientation.VERTICAL}
      defaultFocusChild={defaultFocusChild}
      onMove={onMove}
      disabled={!hasSuggestions}
    >
      {items.map((value) => (
        <SuggestionsItemWrapper key={value}>
          <SuggestionsItem>
            <SuggestionsChip onSelected={() => onSelect(value)}>
              {value}
            </SuggestionsChip>
          </SuggestionsItem>
        </SuggestionsItemWrapper>
      ))}
    </SuggestionsWrapper>
  )
}
